import React from "react";
import { Link } from "react-router-dom";
import projects from "../AllWork.json";
import "./Projects.css";

const Projects = () => {
  return (
    <div id="projectsPage">
      <div className="pt-5">
        {projects.map((project, index) => {
          return (
            <div key={project.projectId} className="col-md-3 projectTile">
              <a href={"/projectInfo/" + project.projectId}>
                <div className="small-card mb-3">
                  <img
                    className="small-card-img-top"
                    src={project.projectImage}
                    alt="Card image cap"
                  />
                  <div className="small-body">
                    <h5 className="small-title text-center">{project.projectName}</h5>
                    <p className="small-text">
                      {project.projectDescription.length > 70
                        ? project.projectDescription.substring(0, [70]) + "..."
                        : project.projectDescription}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Works/Projects/Projects.js